import { ValidationReleaseModel } from '@app/shared/models/validation-release.model';

export class AddValidationRelease {
  static readonly type = '[ValidationRelease] Add Validation Release';
  constructor(public payload: ValidationReleaseModel) { }
}